import * as React from "react";
import Home from "src/pages/Home";
import Layout from "@components/Layout";
import Head from "next/head";

const Index = () => {
  return (
    <Layout>
      <Head>
        {/* Essential SEO */}
        <title>
          Inawo | Africa’s Leading Wedding Management Software & Planning
          Platform
        </title>
        <meta
          name="description"
          content="Plan your entire wedding in one place with Africa’s leading wedding management software and planning platform. Create your wedding website, manage your checklist, guest list, RSVP, digital invites, asoebi, wedding party, wishlist, cash gifts, photobook, live hall, and discover vendors and venues"
        />
        <link rel="canonical" href="https://www.inawo.com" />

        {/* Open Graph */}
        <meta
          property="og:title"
          content="Inawo | Africa’s Leading Wedding Management Software & Planning Platform"
        />
        <meta
          property="og:description"
          content="All you need for a great wedding in one place - Wedding website, digital invitations, wedding vendors, seamless wedding planning and more."
        />
        <meta property="og:url" content="https://www.inawo.com" />
        <meta
          property="og:image"
          content="https://inawo-frontend.s3.us-east-1.amazonaws.com/public/Cover_pcqimz.png"
        />
        <meta property="og:type" content="website" />
        <meta property="og:site_name" content="Inawo" />
        <meta property="og:locale" content="en_US" />

        {/* Twitter */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta
          name="twitter:title"
          content="Inawo — Plan Your Wedding in One Place"
        />
        <meta
          name="twitter:description"
          content="Africa’s leading wedding management software and planning platform. Create your wedding website and manage your checklist, guest list, RSVP, invites, asoebi, vendors, venues, and more."
        />
        <meta
          name="twitter:image"
          content="https://inawo-frontend.s3.us-east-1.amazonaws.com/public/Cover_pcqimz.png"
        />
        <meta name="twitter:site" content="@inawoweddings" />
        <meta name="twitter:creator" content="@inawoweddings" />

        <meta name="viewport" content="width=device-width, initial-scale=1" />
      </Head>
      <Home />
    </Layout>
  );
};

export default Index;
